var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 56.25C44.4975 56.25 56.25 44.4975 56.25 30C56.25 15.5025 44.4975 3.75 30 3.75C15.5025 3.75 3.75 15.5025 3.75 30C3.75 44.4975 15.5025 56.25 30 56.25Z",
    fill: "url(#paint0_linear_24_83)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0999 19.1415C43.3335 17.6312 41.8976 16.4392 40.5547 17.0287L13.809 28.7715C12.8461 29.1943 12.9165 30.6531 13.9153 30.9711L19.4308 32.7276C20.4836 33.0628 21.6234 32.8894 22.5427 32.2543L34.9781 23.6631C35.3531 23.4039 35.7619 23.9372 35.4414 24.2674L26.4902 33.4961C25.6219 34.3914 25.7942 35.9085 26.8387 36.5634L36.8606 42.8481C37.9847 43.5529 39.4307 42.8449 39.6409 41.4864L43.0999 19.1415Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_24_83",
    x1: 30,
    y1: 3.75,
    x2: 30,
    y2: 56.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37BBFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007DBB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.0187641b653393dcd663bb74e6b65374.svg";
export { ForwardRef as ReactComponent };